import styled from 'styled-components';
import { DEVICES } from '../../config/appConfig';

export const HeadingContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 30px;
  gap: 8px;

  .subHeaderStyle {
    color: #f58220;
    font-size: 36px;
    font-weight: 600;
  }
  .paraHeaderStyle {
    color: #000;
    font-size: 16px;
  }
  @media ${DEVICES.tablet} {
    .subHeaderStyle {
      font-size: 32px;
    }
    .paraHeaderStyle {
      font-size: 14px;
    }
  }

  @media ${DEVICES.mobile} {
    .subHeaderStyle {
      font-size: 28px;
    }
    .paraHeaderStyle {
      font-size: 12px;
    }
  }

  @media ${DEVICES.sMobile} {
    .subHeaderStyle {
      font-size: 22px;
    }
    .paraHeaderStyle {
      font-size: 10px;
      text-align: center;
    }
  }
`;
export const HeaderStyled = styled.h3`
  color: #000;
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  ${(props) => props.headerLeftStyle && { color: '#f58220' }}

  @media ${DEVICES.tablet} {
    font-size: 32px;
  }

  @media ${DEVICES.mobile} {
    font-size: 28px;
  }

  @media ${DEVICES.sMobile} {
    font-size: 22px;
  }
`;
